export default __webpack_public_path__ + "static/media/pub.c1d8467f.svg";